import axios, { AxiosResponse } from 'axios';

import { fixtureCampaign } from '../../../tests/fixtures/fixtureCampaign';

export const store = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getCampaignProgress: (storeId: number): Promise<AxiosResponse> =>
    // TODO use endpoint when ready
    // axios.get(`appId/user-campaign-progress?storeIDs=${storeId}`);
    new Promise((resolve) => {
      resolve({
        data: {
          Code: 0,
          Data: [fixtureCampaign],
          DeveloperMessage: null,
          ReloadRestaurant: false,
          StackTrace: null,
          Success: true,
          UserMessage: null,
        },
      });
    }) as any,

  getCollectionDetail: (prId: string): Promise<AxiosResponse> =>
    axios.get(`/Restaurant/PickupRestaurantDetails/${prId}`),

  getCollectionSummaries: (payload): Promise<AxiosResponse> =>
    axios.get(
      '/Restaurant/PickupPhysicalRestaurantSummariesFromCoordinates',
      payload,
    ),

  getDeliveryDetail: (vrId: number, options): Promise<AxiosResponse> =>
    axios.get(`/Restaurant/DeliveryRestaurantDetails/${vrId}`, options),

  getDeliverySummaries: (payload): Promise<AxiosResponse> =>
    axios.get('/Restaurant/DeliveryRestaurantSummaries', payload),

  getLocationAreaData: (prid: number): Promise<AxiosResponse> =>
    axios.get(`/Restaurant/GetLocationAreasForStore?storeId=${prid}`),
};
